<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  style: {
    type: Object as PropType<{ [key: string]: string }>,
  },
  /**
   * Stacking level of the backdrop. Raise it when this modal opens **over** another GlobalModal —
   * at equal z-index the last one in the DOM wins, which is not the one the user just opened.
   * Reference points: GlobalModal 500, CenterModal 501.
   */
  zIndex: {
    type: Number,
    default: 500,
  },
});
</script>

<template>
  <div class="background_modal__grey" :style="{ zIndex }">
    <div class="global_card" :style="style">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";

.global_card {
  width: 100%;
  height: 100%;
  background-color: var(--white-main);
  overflow: auto;
  display: block;
}

@media (max-width: 640px) {
  .global_card {
    padding-bottom: 0;
  }
}
</style>
